import React from 'react';
import { Link } from 'react-router-dom';

// import { bmwTopArrows, dodgeTopArrows } from '../../../images/landingLinks';
import bmwTop from '../../../images/bmwTop.png';
import teslaTop from '../../../images/teslaTop.png';

const Drivesharing = ({
  isVisible,
  currentPage,
  fullpage,
  isMobile,
  signedIn
}) => (
  <div className="landing__section">
    <div className="container section-1__drivesharing">
      <img
        className="section-1__car--image--left"
        alt="heading tesla"
        src={teslaTop}
      />
      <div className="section-1__left">
        <h1 className="section-1__header  section-1__header--big  section-1__header--thin">
          Drivesharing is coming soon.
        </h1>
        <p className="section-1__text section-1__margin-bottom">
          Autzu is coming soon to Los Angeles.
        </p>
        <div className="section-1__buttons-container">
          <Link to="/signup">
            <button className="section-1__drivesharing__button">
              {signedIn ? 'Book Now' : 'Sign Up'}
            </button>
          </Link>
          <Link to="/la/videos">
            <button
              className="section-1__drivesharing__button"
              style={{
                background: '#fff',
                border: '1px solid #128dff',
                color: '#128dff'
              }}>
              {'Watch videos'}
            </button>
          </Link>
        </div>
      </div>
      <img className="section-1__car--image--rightT" src={teslaTop} />
      <div className="section-1__right">
        <img
          className="section-1__image section-1__image--mobile section-1__image--bmw-top-arrows"
          src={teslaTop}
          alt="bmw"
        />
      </div>
    </div>
  </div>
);

export default Drivesharing;



// WEBPACK FOOTER //
// ./src/components/Static/LandingPageLA/Drivesharing.js